export default ({ request }) => ({
  ecomAmzFirstDemandListApi(data = {}) {
    return request({
      url: '/ecom/amz/first/demand/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzFirstDemandDetailApi(data = {}) {
    return request({
      url: '/ecom/amz/first/demand/detail',
      method: 'POST',
      data,
    })
  },
  ecomAmzFirstDemandSaveApi(data = {}) {
    return request({
      url: '/ecom/amz/first/demand/save',
      method: 'POST',
      data,
    })
  },
  ecomAmzFirstDemandAddSaveApi(data = {}) {
    return request({
      url: '/ecom/amz/first/demand/addSave',
      method: 'POST',
      data,
    })
  },
  ecomAmzFirstDemandDelApi(data = {}) {
    return request({
      url: '/ecom/amz/first/demand/del',
      method: 'POST',
      data,
    })
  },
  ecomAmzFirstDemandSubmitApi(data = {}) {
    return request({
      url: '/ecom/amz/first/demand/submit',
      method: 'POST',
      data,
    })
  },
  ecomAmzFirstDemandSubmitPlanApi(data = {}) {
    return request({
      url: '/ecom/amz/first/demand/submitPlan',
      method: 'POST',
      data,
    })
  },
  ecomAmzFirstDemandSubmitProcurementApi(data = {}) {
    return request({
      url: '/ecom/amz/first/demand/submitProcurement',
      method: 'POST',
      data,
    })
  },
  ecomAmzFirstDemandCancelPurchaseApi(data = {}) {
    return request({
      url: '/ecom/amz/first/demand/cancelPurchase',
      method: 'POST',
      data,
    })
  },
  ecomAmzFirstDemandReviewApi(data = {}) {
    return request({
      url: '/ecom/amz/first/demand/review',
      method: 'POST',
      data,
    })
  },
  ecomAmzFirstDemandRejectApi(data = {}) {
    return request({
      url: '/ecom/amz/first/demand/reject',
      method: 'POST',
      data,
    })
  },
  ecomAmzFirstDemandDetailListApi(data = {}) {
    return request({
      url: '/ecom/amz/first/demand/detail/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzFirstDemandDetailDelApi(data = {}) {
    return request({
      url: '/ecom/amz/first/demand/detail/del',
      method: 'POST',
      data,
    })
  },
  ecomAmzFirstDemandDetailDetailApi(data = {}) {
    return request({
      url: '/ecom/amz/first/demand/detail/detail',
      method: 'POST',
      data,
    })
  },
  ecomAmzFirstDemandDetailEditSaveApi(data = {}) {
    return request({
      url: '/ecom/amz/first/demand/detail/edit/save',
      method: 'POST',
      data,
    })
  },
  ecomAmzFirstDemandDetailAddSaveApi(data = {}) {
    return request({
      url: '/ecom/amz/first/demand/detail/add/save',
      method: 'POST',
      data,
    })
  },
  ecomAmzFirstDemandSpuListApi(data = {}) {
    return request({
      url: '/ecom/amz/first/demand/spu/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzFirstDemandSpuSaveApi(data = {}) {
    return request({
      url: '/ecom/amz/first/demand/spu/save',
      method: 'POST',
      data,
    })
  },
  ecomAmzFirstDemandSpuDelApi(data = {}) {
    return request({
      url: '/ecom/amz/first/demand/spu/del',
      method: 'POST',
      data,
    })
  },
  ecomAmzFirstDemandDetailPageListApi(data = {}) {
    return request({
      url: '/ecom/amz/first/demand/detail/page/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzFirstDemandDetailBatchModifyApi(data = {}) {
    return request({
      url: '/ecom/amz/first/demand/detail/batchModify',
      method: 'POST',
      data,
    })
  },
  ecomAmzFirstDemandPredictListApi(data = {}) {
    return request({
      url: '/ecom/amz/first/demand/predict/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzFirstDemandPredictUpdateApi(data = {}) {
    return request({
      url: '/ecom/amz/first/demand/predict/update',
      method: 'POST',
      data,
    })
  },
  ecomAmzFirstDemandSpuDetailApi(data = {}) {
    return request({
      url: '/ecom/amz/first/demand/spu/detail',
      method: 'POST',
      data,
    })
  },
  ecomAmzFirstDemandSubmitReviewApi(data = {}) {
    return request({
      url: '/ecom/amz/first/demand/submit/review',
      method: 'POST',
      data,
    })
  },
  ecomAmzFirstDemandReviewListApi(data = {}) {
    return request({
      url: '/ecom/amz/first/demand/review/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzFirstDemandPromotionListApi(data = {}) {
    return request({
      url: '/ecom/amz/first/demand/promotion/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzFirstDemandPromotionDetailApi(data = {}) {
    return request({
      url: '/ecom/amz/first/demand/promotion/detail',
      method: 'POST',
      data,
    })
  },
  ecomAmzFirstDemandPromotionSaveApi(data = {}) {
    return request({
      url: '/ecom/amz/first/demand/promotion/save',
      method: 'POST',
      data,
    })
  },
  ecomAmzFirstDemandPromotionStoreRegionApi(data = {}) {
    return request({
      url: '/ecom/amz/first/demand/promotion/storeRegion',
      method: 'POST',
      data,
    })
  },
  ecomAmzFirstDemandPromotionDelApi(data = {}) {
    return request({
      url: '/ecom/amz/first/demand/promotion/del',
      method: 'POST',
      data,
    })
  },
  ecomAmzFirstDemandPromotionClearApi(data = {}) {
    return request({
      url: '/ecom/amz/first/demand/promotion/clear',
      method: 'POST',
      data,
    })
  },
  ecomAmzFirstDemandPromotionClearAllApi(data = {}) {
    return request({
      url: '/ecom/amz/first/demand/promotion/clear/all',
      method: 'POST',
      data,
    })
  },
  ecomAmzFirstDemandPromotionGenerateApi(data = {}) {
    return request({
      url: '/ecom/amz/first/demand/promotion/generate',
      method: 'POST',
      data,
    })
  },
  ecomAmzFirstDemandPromotionDelRowApi(data = {}) {
    return request({
      url: '/ecom/amz/first/demand/promotion/del/row',
      method: 'POST',
      data,
    })
  },
})
